module.exports = __webpack_public_path__ + "img/icon-customs.384da731.svg";